jQuery(document).ready(function($) {

  // initialize foundation
  $(document).foundation()

  // show body after load
  setTimeout(function() {
    $('body').addClass('is-visible')
  }, 200)


  // about slideshow
  if ($('.carousel-about').length > 0) {
    var initialIndex = Math.floor( Math.random() * $('.carousel-about .carousel-cell').length )
    var $carouselAbout = $('.carousel-about').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      percentPosition: false,
      resize: true,
      setGallerySize: false,
      wrapAround: true,
      draggable: false,
      pauseAutoPlayOnHover: false,
      fade: true,
      autoPlay: 3500,
      initialIndex: initialIndex,
      on: {
        ready: function() {
          $('.captions-carousel-about').each(function() {
            $(this).find('span.caption-text').eq(initialIndex).addClass('is--showing')
          })
          $('.carousel-about').removeAttr('tabindex')
        },
        change: function (index) {
          $('.captions-carousel-about').each(function() {
            $(this).find('span.caption-text').removeClass('is--showing').eq(index).addClass('is--showing')
          })
        }
      }
    })
    $('.carousel-about-container .controls button').on('click', function() {
      $('.carousel-about-container').toggleClass('is-paused')
      if ($('.carousel-about-container').hasClass('is-paused')) {
        $carouselAbout.flickity('stopPlayer')
      } else {
        $carouselAbout.flickity('playPlayer')
      }
    })
  }

  // timeline decades
  $('.node--type-timeline').on('click', ' .decades a', function(e) {
    var decade = $(this).attr('href').replace('#', '')
    var offsetTop = $('.node--type-timeline a.name[data-decade="' + decade + '"]').first().offset().top
    $('html, body').animate({ scrollTop: offsetTop - 40 }, 500)
    e.preventDefault()
  })

  // node names letters filter
  $('.node--type-names').on('click', '.letters a', function(e) {
    var letter = $(this).attr('href').replace('#', '')
    var offsetTop = $('.node--type-names .name-container[data-letter="' + letter + '"]').first().offset().top
    $('html, body').animate({ scrollTop: offsetTop - 10 }, 500)
    e.preventDefault()
  })

  // show slideshow
  $('.node--type-profile .project .image').on('click', function(e) {
    if (Foundation.MediaQuery.is('medium up')) {
      e.stopPropagation()
      e.preventDefault()
      var initialIndex = $(this).index()
      var $project = $(this).parent()

      // update counter
      $('#reveal-project .counter .total').html($project.find('.image').length)
      $('#reveal-project .counter .current').html(1)

      var html = '<div class="carousel">'

      // addd carousel slides
      $project.find('.image').each(function() {
        var $image = $(this)
        var imageIndex = $image.index()
        var videoUrl = $image.data('video-url')
        html += '<div class="carousel-cell">'
          html += '<div class="flex-container flex-dir-column image-caption">'
            if (videoUrl && (videoUrl.includes('youtube.com') || videoUrl.includes('vimeo.com'))) {
              var videoId = ''
              var videoIframe = videoUrl
              // youtube
              if (videoUrl.includes('youtube.com')) {
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                var match = videoUrl.match(regExp);
                videoId = (match&&match[7].length==11)? match[7] : false;
                if (initialIndex == imageIndex) {
                  videoIframe = '<iframe src="//www.youtube.com/embed/' + videoId + '?rel=0&enablejsapi=1&autoplay=1" allowfullscreen title="Embedded video"></iframe>'
                } else {
                  videoIframe = '<iframe src="//www.youtube.com/embed/' + videoId + '?rel=0&enablejsapi=1" allowfullscreen title="Embedded video"></iframe>'
                }
                html += '<div class="flex-child-auto image video youtube">' + videoIframe + '</div>'
              }
              // vimeo
              if (videoUrl.includes('vimeo.com')) {
                var regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/
                var match = videoUrl.match(regExp)
                if (match[2]) {
                  videoId = match[2]
                  if (initialIndex == imageIndex) {
                    videoIframe = '<iframe src="https://player.vimeo.com/video/' + videoId + '?autoplay=1" allowfullscreen></iframe>';
                  } else {
                    videoIframe = '<iframe src="https://player.vimeo.com/video/' + videoId + '" allowfullscreen></iframe>';
                  }
                  html += '<div class="flex-child-auto image video vimeo">' + videoIframe + '</div>'
                }
              }
            } else {
              html += '<div class="flex-child-auto image" style="background-image: url(' + $image.data('large-image-path') + ');"></div>'
            }
            html += '<div class="flex-child-shrink caption">'
              html += '<span>' + $image.data('category') + ':</span>' + $image.find('.caption').html()
            html += '</div>'
          html += '</div>'
        html += '</div>'
      })

      html += '</div>'

      $('#reveal-project .counter .current').html(initialIndex + 1)

      $('#reveal-project').foundation('open')

      $('#reveal-project .carousel-container').empty().html(html)

      // carousel project
      var $carousel = $('.carousel').flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        percentPosition: false,
        resize: true,
        setGallerySize: false,
        wrapAround: true,
        draggable: true,
        initialIndex: initialIndex,
        on: {
          select: function() {
            if ($carousel) {
              var currentIndex = $carousel.data('flickity').selectedIndex
              // update counter
              $('#reveal-project .counter .current').html(currentIndex + 1)
              // pause all youtube
              $('.carousel-cell .youtube').each(function() {
                var iframe = $(this).find('iframe')[0]
                iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
              })
              // pause all vimeo
              $('.carousel-cell .vimeo').each(function() {
                var iframe = $(this).find('iframe')[0]
                iframe.contentWindow.postMessage('{"method":"pause"}', '*')
              })
              // play youtube video if its current
              var $cell = $carousel.find('.carousel-cell').eq(currentIndex)
              if ($cell.find('.youtube').length > 0) {
                var iframe = $cell.find('iframe')[0]
                iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
              }
              if ($cell.find('.vimeo').length > 0) {
                var iframe = $cell.find('iframe')[0]
                iframe.contentWindow.postMessage('{"method":"play"}', '*')
              }
            }
          }
        }

      })

      $('#reveal-project .previous').off('click').on('click', function() {
        $carousel.flickity('previous')
      }).off('keypress').on('keypress', function(e) {
        if (e.which == 32 || e.which == 13) {
          $carousel.flickity('previous')
        }
      })

      $('#reveal-project .next').off('click').on('click', function() {
        $carousel.flickity('next')
      }).off('keypress').on('keypress', function(e) {
        if (e.which == 32 || e.which == 13) {
          $carousel.flickity('next')
        }
      })

      $('#reveal-project .close').on('click', function() {
        $('#reveal-project').foundation('close')
        $('#reveal-project .carousel-container').empty()
      }).off('keypress').on('keypress', function(e) {
        if (e.which == 32 || e.which == 13) {
          $('#reveal-project').foundation('close')
        }
      })

    }
  }).keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click');
      e.preventDefault();
    }
  })

  // works - load more
  $('.node--type-works').on('click', '.more a', function(e) {
    $('.node--type-works .grid-set.hide').slice(0, 4).removeClass('hide')
    if ($('.node--type-works .grid-set.hide').length == 0) {
      $(this).remove()
    }
    e.preventDefault()
  }).keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click');
      e.preventDefault();
    }
  })

  // filters search
  $('.filters input[type="text"]').on('focus', function() {
    $('.filters form').addClass('form--is-active')
  })

  $('.filters').on('submit', function() {
    window.location = '?keyword=' + $('.filters input[type="text"]').val() + '#filters'
    return false
  })

  $('.filters .cell-departments a').on('click', function(e) {
    var $a = $(this)
    $('.filters .cell-departments a').removeClass('is-active')
    $a.addClass('is-active')
    var url = $a.attr('href').replace('#filters', '')
    history.pushState(null, null, url)
    $.ajax({
      url: url,
      cache: true,
      dataType: 'html',
      beforeSend: function(xhr) {
        $('article').addClass('results--is-loading')
      }
    }).done(function(html) {
      var articleHtml = $(html).filter('.page').find('article').html()
      setTimeout(function() {
        $('article').html(articleHtml).removeClass('results--is-loading')
      })
    }).fail(function(error) {
      alert('Error loading ' + href)
    })
    e.preventDefault()
  })

  // jump to filters section
  var href = window.location.href
  if (href.indexOf('?tid') > -1 || href.indexOf('works') > -1 || href.indexOf('names') > -1 || href.indexOf('timeline') > -1 || href.indexOf('keyword') > -1) {
    $('html, body').animate({ scrollTop: $('.filters').offset().top - 40 }, 0)
    $('#filter-by').focus()
  }

  // browse profiles
  $('a[href^="#browse-profiles"]').on('click', function(e) {
    var offsetTop = $('.filters').offset().top
    $('html, body').animate({ scrollTop: offsetTop - 40 }, 500)
    e.preventDefault()
  })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

});
